import { route, tag, type PageTour } from '../pageTour';

export const attendanceConfigTour: PageTour = {
  id: 'page-attendance-config',
  version: 1,
  title: 'Attendance Settings',
  summary: 'Shifts, working hours and attendance rules.',
  match: route('/attendance/config'),
  steps: [
    {
      target: tag('attendance-toolbar'),
      title: 'Find a camera',
      description: 'Search the cameras on this site by name.',
      side: 'bottom',
      permission: 'attendance.config',
    },
    {
      target: tag('attendance-table'),
      title: 'Entry and exit cameras',
      description: 'Give each camera a role, such as entry or exit, so attendance knows when someone comes in or leaves. Module-wide options are under the Settings tab above.',
      side: 'top',
      permission: 'attendance.config',
    },
    {
      target: tag('attendance-config-refresh'),
      title: 'Refresh',
      description: 'Reload the camera list.',
      side: 'bottom',
      permission: 'attendance.config',
    },
  ],
};
